import { useState } from "react";
import { toast } from "sonner";
import api, { apiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Badge } from "@/components/ui/badge";
import { Plus, GitMerge, X } from "lucide-react";

export const CustomerHeader = ({ customer, customerId, isAdmin, onUpdated, onAddOrder, onMerge }) => {
  const [tagInput, setTagInput] = useState("");

  const addTag = async () => {
    const t = tagInput.trim();
    if (!t) return;
    try {
      const { data } = await api.patch(`/customers/${customerId}`, { tags: [...(customer.tags || []), t] });
      onUpdated(data);
      setTagInput("");
    } catch (e) { toast.error(apiError(e)); }
  };

  const removeTag = async (t) => {
    try {
      const { data } = await api.patch(`/customers/${customerId}`, { tags: (customer.tags || []).filter((x) => x !== t) });
      onUpdated(data);
    } catch (e) { toast.error(apiError(e)); }
  };

  return (
    <div className="flex flex-wrap items-start justify-between gap-4">
      <div>
        <h1 className="text-4xl sm:text-5xl font-serif font-semibold" data-testid="customer-name">
          {customer.first_name} {customer.last_name}
        </h1>
        <div className="flex flex-wrap items-center gap-2 mt-3">
          {(customer.tags || []).map((t) => (
            <Badge key={t} variant="secondary" className="gap-1" data-testid={`tag-${t}`}>
              {t}
              <button onClick={() => removeTag(t)} aria-label={`Remove tag ${t}`}><X className="h-3 w-3" /></button>
            </Badge>
          ))}
          <div className="flex items-center gap-1">
            <Input value={tagInput} onChange={(e) => setTagInput(e.target.value)} onKeyDown={(e) => e.key === "Enter" && addTag()} placeholder="Add a tag" className="h-7 w-28 text-xs" data-testid="add-tag-input" />
            <Button size="sm" variant="ghost" className="h-7 px-2" onClick={addTag} data-testid="add-tag-btn"><Plus className="h-3 w-3" /></Button>
          </div>
        </div>
      </div>
      <div className="flex gap-2">
        <Button onClick={onAddOrder} data-testid="add-order-btn"><Plus className="h-4 w-4 mr-2" /> Add an Order</Button>
        {isAdmin && (
          <Button variant="secondary" onClick={onMerge} data-testid="merge-customer-btn">
            <GitMerge className="h-4 w-4 mr-2" /> Merge
          </Button>
        )}
      </div>
    </div>
  );
};
